type LinkType = "external" | "event" | "venue";

type Link = {
    type: LinkType;
    data: string;
};

export type NewsItem = {
    title: string,
    body: string,
    imageUrl: string,
    link: Link
}

export module NewsItem {
    function createDefault(): NewsItem {
        return {
            title: "Placeholder",
            body: "Placeholder",
            imageUrl: "Placeholder",
            link: {
                type: "external",
                data: "https://example.org"
            }
        }
    }
}